import { FunctionComponent } from "react";

export const CentredSpinner: FunctionComponent = () => {
  return (
    <div style={{ width: "100vw", height: "100vh" }}>
      <div
        style={{
          margin: 0,
          position: "absolute",
          top: "50%",
          left: "50%",
          msTransform: "translate(-50%, -50%)",
          transform: "translate(-50%, -50%)"
        }}>
        <div className="spinner-border centerWrapper" role="status">
          <span className={"visually-hidden"}> Loading... </span>
        </div>
      </div>
    </div>
  );
};
